import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const schema = yup.object().shape({
  supplier_id: yup.string().required("Supplier is required"),
  category_id: yup.string().required("PO category is required"),
  // store_id: yup.string().required("Store is required"),
  po_date: yup.string().required("PO date is required"),
  items: yup
    .array()
    .min(1, "Please add at least one item to the Purchase Order")
    .of(
      yup.object().shape({
        requested_quantity: yup
          .mixed()
          .test(
            "required-qty",
            "Quantity is required and must be greater than 0",
            (val) =>
              val !== undefined &&
              val !== null &&
              val !== "" &&
              Number(val) > 0,
          ),
        cost_price: yup
          .mixed()
          .test(
            "required-cost",
            "Cost price is required",
            (val) =>
              val !== undefined &&
              val !== null &&
              val !== "" &&
              Number(val) >= 0,
          ),
      }),
    ),
});

export const useValidation = ({ ...params }) => {
  return useForm({
    resolver: yupResolver(schema),
    mode: "onBlur",
    shouldFocusError: true,
    defaultValues: {
      ...params,
    },
  });
};
